<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">
        <section slot="above-content" class="gz-action-section_default">
            <GZ-BaseButton
                value="добавить проверку"
                class="gz-button gz-button_default" 
                icon="icon-clipboard"
                @click="setCheckup"
            />
        </section>

        <section slot="content" v-if="contentLoading">
            <GZ-MainPageLoader />
        </section>
        <table class="gz-table" slot="content">
            <thead class="gz-table__head">
                <tr class="gz-table__filter-labels gz-table__filter-labels_solid">
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Дата проверки</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Кто проверил</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Номер акта</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Статус</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Верификация</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Фото</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Комментарии</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Опции</span></td>
                </tr>
            </thead>
            <tbody 
                v-for="(item, index) in checkupsComputed"
                :key="index"
            >
                <CheckupRow :item="item"/>
            </tbody>
        </table>
    </gz-auth-view-template>
</template>

<script>
import CheckupRow from '@/components/custom/admin/views/addresses/CheckupRow'
import Checkup from '@/components/custom/admin/views/addresses/BaseCheckup'

export default {
    name: 'SingleShelterSchedule',

    components: {
        CheckupRow
    },
    data() {
        return {
            checkups: [],
            contentLoading: false
        }
    },
    computed: {
        addressCheckupStatus() {
        //Меняет значение после добавления/редактирования проверки. Отрабатывает в watch
            return this.$store.getters['addressCheckupStatus']
        },
        checkupsComputed() {
            return this.checkups
        }
    },
    mounted() {
        this.contentLoading = true
        this.$store.dispatch('checkupsPropertyGet', this.$route.params.id)
            .then(() => {
                this.checkups = this.$store.getters['checkupsProperty']
                this.contentLoading = false
            })
    },
    methods: {
        setCheckup() {
        //Добавить проверку
            this.$store.dispatch('modalOpen', {
                component: Checkup,
                data: {
                    id: this.$route.params.id,
                    objectType: 'pid'
                }               
            })
        }
    },
    watch: {
        addressCheckupStatus: function() {
            this.contentLoading = true
            this.$store.dispatch('checkupsPropertyGet', this.$route.params.id)
                .then(() => {
                    this.checkups = this.$store.getters['checkupsProperty']
                    this.contentLoading = false
                })
        }
    }
}
</script>